"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const jwt_decode_1 = require("jwt-decode");
const app_user_1 = require("../AppUser/app-user");
const random_1 = require("../Utils/random");
const refreshTokenLocalStorageName = "refresh_token";
const accessTokenLocalStorageName = "access_token";
const codeVerifierLocalStorageName = "code_verifier";
class Auth {
    constructor(config) {
        this.config = config;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.getToken();
            if (token === null) {
                return null;
            }
            this.startRenew();
            return new app_user_1.AuthenticatedUser((0, jwt_decode_1.jwtDecode)(token));
        });
    }
    getUser() {
        const token = localStorage.getItem(accessTokenLocalStorageName);
        if (!token) {
            return null;
        }
        return new app_user_1.AuthenticatedUser((0, jwt_decode_1.jwtDecode)(token));
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const refreshToken = localStorage.getItem(refreshTokenLocalStorageName);
            const accessToken = localStorage.getItem(accessTokenLocalStorageName);
            if (refreshToken) {
                yield this.performSilentSignIn(refreshToken);
            }
            else if (!refreshToken) {
                yield this.performSignIn();
            }
            return localStorage.getItem(accessTokenLocalStorageName);
        });
    }
    // called when authenticated has been performed by the user
    // and a code is received that we should exchange for access and refresh token
    completeAuthentication(code, onSuccess, onError) {
        return __awaiter(this, void 0, void 0, function* () {
            const verifier = this.getCodeVerifier();
            this.removeCodeVerifier();
            try {
                const response = yield fetch(`${this.config.authority}/token/access?client_id=${this.config.clientId}&code=${code}&verifier=${verifier}`, { method: "POST" });
                this.log("called exchange with response status code", response.status);
                if (response.status !== 200) {
                    throw new Error("Invalid status code");
                }
                const result = yield response.json();
                this.log("received authentication result", result);
                if (onSuccess) {
                    localStorage.setItem(accessTokenLocalStorageName, result.access_token);
                    localStorage.setItem(refreshTokenLocalStorageName, result.refresh_token);
                    onSuccess();
                }
            }
            catch (_a) {
                this.clearLocalStorage();
                if (onError) {
                    onError("Invalid status code recvieved from server, enable verbose to see logs");
                }
            }
        });
    }
    accessToken() {
        return localStorage.getItem(accessTokenLocalStorageName);
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearLocalStorage();
            window.location.href = `${this.config.authority}/auth/logout?redirect_url=${this.config.redirectUrl}`;
        });
    }
    clearLocalStorage() {
        localStorage.removeItem(refreshTokenLocalStorageName);
        localStorage.removeItem(accessTokenLocalStorageName);
        localStorage.removeItem(codeVerifierLocalStorageName);
    }
    log(...log) {
        if (this.config.verbose) {
            console.log(log);
        }
    }
    createCodeVerifier() {
        const codeVerifier = (0, random_1.createRandomId)(32);
        localStorage.setItem(codeVerifierLocalStorageName, codeVerifier);
    }
    getCodeVerifier() {
        return localStorage.getItem(codeVerifierLocalStorageName);
    }
    removeCodeVerifier() {
        localStorage.removeItem(codeVerifierLocalStorageName);
    }
    getCodeChallenge() {
        return __awaiter(this, void 0, void 0, function* () {
            const buffer = yield crypto.subtle.digest("SHA-256", new TextEncoder().encode(this.getCodeVerifier()));
            const hashArray = Array.from(new Uint8Array(buffer));
            return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
        });
    }
    performSignIn() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearLocalStorage();
            this.createCodeVerifier();
            const challenge = yield this.getCodeChallenge();
            const authCallbackUrl = this.config.redirectUrl + "/" + "auth-callback";
            window.location.assign(`${this.config.authority}/auth/authorize?client_id=${this.config.clientId}&redirect_url=${authCallbackUrl}&code_challenge=${challenge}`);
        });
    }
    performSilentSignIn(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(`${this.config.authority}/token/refresh?client_id=${this.config.clientId}&refresh_token=${refreshToken}`, { method: "POST" });
                if (response.status !== 200) {
                    throw new Error("Invalid status code");
                }
                const result = yield response.json();
                localStorage.setItem(accessTokenLocalStorageName, result.access_token);
            }
            catch (_a) {
                yield this.performSignIn();
            }
        });
    }
    isAccessTokenNearExpiration() {
        const token = localStorage.getItem(accessTokenLocalStorageName);
        if (!token) {
            return true;
        }
        const parsedToken = (0, jwt_decode_1.jwtDecode)(token);
        const threshold = 60 * 10; // 10 minutes
        return parsedToken["exp"] - Date.now() / 1000 < threshold;
    }
    startRenew() {
        setInterval(() => {
            if (this.isAccessTokenNearExpiration()) {
                this.getToken().then();
            }
            else {
                this.log("refresh needed not needed");
            }
        }, 60000);
    }
}
exports.Auth = Auth;
